/**
 * Add extra attributes to an order based on URL parameters
 *
 * gn => Groepsnaam / groupname, for example: Vissenkom
 * sn => Schoolnummer / Schoolnumber, for example S-07547
 * kc => Kindcode / Child code = ADE3F
 * utm_medium => The medium where the customer came from
 * utm_source => Source where client came from
 * utm_campaign => The current campaign
 */

import Cookies from 'js-cookie'

Date.prototype.addHours = function(h){
  this.setHours(this.getHours()+h);
  return this;
}

Date.prototype.addMinutes = function(h){
  this.setMinutes(this.getMinutes()+h);
  return this;
}

class OrderAttributes {
  constructor() {

    // Variables
    this.expiresInHours = window.expiresInHours ? window.expiresInHours : 24;
    this.expiresInMinutes = 0;

    // Init
    this.clearCampaignCookies();
    this.getOrderAttributes();
    this.saveOrderAttributes();
  }

  // Clear campaign cookies when a customer has completed checkout and placed a order
  // Works together with the clear-campaign-cookies key in the local storage of the campaign cookies extension
  clearCampaignCookies() {
    // Get local checkout extension storage
    let extensionStorage = parseJson(window.localStorage.getItem('extensionStorage'));

    // Check if the local storage includes the clear-campaign-cookies key in the name
    const clearCampaignCookies = extensionStorage && Object.keys(extensionStorage).find(key => key.includes('clear-campaign-cookies'));

    // Return if the clearCampaignCookies key is not found
    if (!clearCampaignCookies) {
      return;
    }

    // Clear all campaign cookies
    Cookies.remove('gn');
    Cookies.remove('sn');
    Cookies.remove('kc');
    Cookies.remove('utm_medium');
    Cookies.remove('utm_source');
    Cookies.remove('utm_campaign');

    // Remove the clearCampaignCookies key from the extension storage
    delete extensionStorage[clearCampaignCookies]

    // Set the new extension storage
    window.localStorage.setItem('extensionStorage', JSON.stringify(extensionStorage));
  }

  // Get order attributes from url to cookies
  getOrderAttributes() {
    if (!window.location.search || !window.localStorage) {
      return false;
    }

    let params = new URLSearchParams(window.location.search);

    if (!params.get('gn') && !params.get('sn') && !params.get('kc') && !params.get('utm_medium') && !params.get('utm_source') && !params.get('utm_campaign')) {
      return false;
    }

    let gn = params.get('gn') ? params.get('gn') : '';
    let sn = params.get('sn') ? params.get('sn') : '';
    let kc = params.get('kc') ? params.get('kc') : '';
    let medium = params.get('utm_medium') ? params.get('utm_medium') : '';
    let source = params.get('utm_source') ? params.get('utm_source') : '';
    let campaign = params.get('utm_campaign') ? params.get('utm_campaign') : '';
    let expires = new Date().addHours(this.expiresInHours).addMinutes(this.expiresInMinutes);

    if (gn) {
      Cookies.set('gn', gn, { expires: expires });
    } else {
      Cookies.remove('gn');
    }


    if (sn) {
      Cookies.set('sn', sn, { expires: expires });
    } else {
      Cookies.remove('sn');
    }

    if (kc) {
      Cookies.set('kc', kc, { expires: expires });
    } else {
      Cookies.remove('kc');
    }

    if (medium) {
      Cookies.set('utm_medium', medium, { expires: expires });
    } else {
      Cookies.remove('utm_medium');
    }

    if (source) {
      Cookies.set('utm_source', source, { expires: expires });
    } else {
      Cookies.remove('utm_source');
    }

    if (campaign) {
      Cookies.set('utm_campaign', campaign, { expires: expires });
    } else {
      Cookies.remove('utm_campaign');
    }
  }

  // Add order attributes on cart page.
  async saveOrderAttributes() {
    if (!document.body.classList.contains('template-cart')) {
      return false;
    }

    let formData = {
      attributes: {}
    };

    if (Cookies.get('gn') != '' && Cookies.get('gn') != undefined) {
      document.querySelector('[name="attributes[gn]"]').value = Cookies.get('gn');
      formData.attributes.gn = Cookies.get('gn');
    }

    if (Cookies.get('sn') != '' && Cookies.get('sn') != undefined) {
      document.querySelector('[name="attributes[sn]"]').value = Cookies.get('sn');
      formData.attributes.sn = Cookies.get('sn');
    }

    if (Cookies.get('kc') != '' && Cookies.get('kc') != undefined) {
      document.querySelector('[name="attributes[kc]"]').value = Cookies.get('kc');
      formData.attributes.kc = Cookies.get('kc');
    }

    if (Cookies.get('utm_medium') != '' && Cookies.get('utm_medium') != undefined) {
      document.querySelector('[name="attributes[utm_medium]"]').value = Cookies.get('utm_medium');
      formData.attributes.utm_medium = Cookies.get('utm_medium');
    }

    if (Cookies.get('utm_source') != '' && Cookies.get('utm_source') != undefined) {
      document.querySelector('[name="attributes[utm_source]"]').value = Cookies.get('utm_source');
      formData.attributes.utm_source = Cookies.get('utm_source');
    }

    if (Cookies.get('utm_campaign') != '' && Cookies.get('utm_campaign') != undefined) {
      document.querySelector('[name="attributes[utm_campaign]"]').value = Cookies.get('utm_campaign');
      formData.attributes.utm_campaign = Cookies.get('utm_campaign');
    }

    const body = JSON.stringify(formData);
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {...fetchConfig(), ...{ body }});
    const data = await response.json();

  }

}

window.OrderAttributes = new OrderAttributes();
